import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c745bb70&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c745bb70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c745bb70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c745bb70')) {
      api.createRecord('c745bb70', component.options)
    } else {
      api.reload('c745bb70', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c745bb70&scoped=true", function () {
      api.rerender('c745bb70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/blend/index.vue"
export default component.exports